export default "__VITE_ASSET__1ed9b7f1__"